import { capture } from "./capture";

export const KnowledgeTracking = {
  /** Upload tab selected in knowledge source create/edit form. */
  uploadTabSelected: (knowledgeSourceId: string | null) => {
    capture("knowledge.upload_tab_selected", {
      knowledge_source_id: knowledgeSourceId,
    });
  },

  /** Knowledge source created successfully. */
  sourceCreated: (uploadMode: string, privacy: string) => {
    capture("knowledge.source_created", { upload_mode: uploadMode, privacy });
  },

  /** Knowledge source creation failed. */
  sourceCreateFailed: (error: string) => {
    capture("knowledge.source_create_failed", { error });
  },

  /** Knowledge source edited. */
  sourceEdited: (sourceId: string | number) => {
    capture("knowledge.source_edited", { source_id: sourceId });
  },

  /** Knowledge source edit failed. */
  sourceEditFailed: (sourceId: string | number, error: string) => {
    capture("knowledge.source_edit_failed", { source_id: sourceId, error });
  },

  /** Knowledge source deleted. */
  sourceDeleted: (sourceId: string | number) => {
    capture("knowledge.source_deleted", { source_id: sourceId });
  },

  /** Document uploaded to a knowledge source. */
  documentUploaded: (sourceId: string | number, fileType: string) => {
    capture("knowledge.document_uploaded", { source_id: sourceId, file_type: fileType });
  },

  /** Knowledge base template forked. */
  templateForked: (templateName: string) => {
    capture("knowledge.template_forked", { template_name: templateName });
  },

  /** Feedback submitted for a learning. */
  learningFeedbackSubmitted: (
    sourceId: string | number,
    learningId: string | number,
    feedback: string,
  ) => {
    capture("knowledge.learning_feedback_submitted", {
      source_id: sourceId,
      learning_id: learningId,
      feedback,
    });
  },

  /** Document processing retried. */
  processingRetried: (sourceId: string | number, documentId: string | number) => {
    capture("knowledge.processing_retried", { source_id: sourceId, document_id: documentId });
  },

  /** Knowledge source link copied. */
  linkCopied: (sourceId: string | number) => {
    capture("knowledge.link_copied", { source_id: sourceId });
  },
};
